export type GiftFields = {
  isGift: boolean;
  isGiftRemovable?: boolean;
  parentGiftSku?: string;
};

export const isStandaloneGift = (item: GiftFields) => {
  return item.isGift && !item.parentGiftSku && !item.isGiftRemovable;
};
